import { render, staticRenderFns } from "./FeedbackEditDialog.vue?vue&type=template&id=081a25db&scoped=true"
import script from "./FeedbackEditDialog.vue?vue&type=script&lang=js"
export * from "./FeedbackEditDialog.vue?vue&type=script&lang=js"
import style0 from "./FeedbackEditDialog.vue?vue&type=style&index=0&id=081a25db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081a25db",
  null
  
)

export default component.exports